export default "__VITE_ASSET__sT8QUsfr__"